var exports = {
  "H": "xfd349460--afcab5--basic",
  "n": "xfd349460--afcab5--controls",
};

module.exports = exports;
